import React from "react";
import { Link } from "react-router-dom";
import client from "@culturehq/client";
import { Icon, Panel } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import ViewAllLink from "components/common/ViewAllLink";

import styles from "./styles.module.scss";

const EventPhotos = () => {
  const { fetching, json: { photos = [] } } = useFetch(client.getPhotoGallery);

  if (!fetching && photos.length === 0) {
    return null;
  }

  return (
    <Panel className="SidePanel">
      <Panel.Heading>
        <ViewAllLink to="/photos" />
        <Icon icon="images" />
        <Trans>Photos</Trans>
      </Panel.Heading>
      <Panel.LoaderBody loading={fetching}>
        <ErrorBoundary>
          <div className={styles["photo-list"]}>
            {photos.slice(0, 6).map((photo, index) => (
              <Link
                key={photo.id}
                to={`/photos#${index}`}
                className={styles.photo}
                style={{ backgroundImage: `url(${photo.image.mediumUrl})` }}
                aria-label={t(`${photo.event.name} - image`)}
              />
            ))}
          </div>
        </ErrorBoundary>
      </Panel.LoaderBody>
    </Panel>
  );
};

export default EventPhotos;
